import React, { Component } from 'react';
import { Grid, Row } from 'react-bootstrap';
import { NavMenu } from './NavMenu';
import './customfont.css';
import './NavMenu.css';

export class Layout extends Component {
    displayName = Layout.name

    render() {
        return (
            <Grid fluid>
                <Row>
                    <NavMenu />
                </Row>
                <Row>
                    <h1 className="welcome"><b>SLA Online Complaint</b></h1>
                    <br/>
                    {this.props.children}
                </Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout.js